import { useState, useEffect } from "react";
import { NavLink, useNavigate, Link } from "react-router-dom";
import { LayoutGrid, ShoppingCart, Heart, X } from "lucide-react";
import "../../assets/styles/components/Mobiletab/BottomTab.css";
import WishlistModal from "../Wishlist/WishlistModal";
import { useCartWishlist } from "../../app/CartWishlistContext";
import { FaWhatsapp } from "react-icons/fa";
import API from "../../app/api";
import { Home } from "react-feather";
import { getBannercategories } from "../../features/Home/services/bannercategories.service";
import { getCategoryUrl } from "../../utils/url.utils";

const BottomTab = () => {
  const [showCategories, setShowCategories] = useState(false);
  const [showwishlist, setShowwishlist] = useState(false);
  const [wdata, setData] = useState({});
  const [categories, setCategories] = useState([]);

  const navigate = useNavigate();
  const { countData } = useCartWishlist();

  /* ---------------- WHATSAPP SUPPORT ---------------- */
  const chatsupport = async () => {
    try {
      const res = await API.get("/chat/support");
      if (res?.data?.status === 200) {
        setData(res.data.data);
      }
    } catch (err) {
      console.log("Chat support error:", err);
    }
  };

  /* ---------------- CATEGORIES API ---------------- */
  const fetchCategories = async () => {
    try {
      const data = await getBannercategories(); // directly array
      setCategories(data);
    } catch (error) {
      console.log("Category fetch error:", error);
    }
  };

  useEffect(() => {
    fetchCategories();
    chatsupport();
  }, []);

  /* ---------------- WISHLIST ---------------- */

  const handleWishlistClick = () => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/login");
      return;
    }

    setShowwishlist(true);
  };


  return (
    <>
      {/* BOTTOM NAV */}
      <div className="bottom-tab">
        {/* HOME */}
        <NavLink
          to="/"
          end
          className={({ isActive }) => `tab-item ${isActive ? "active" : ""}`}
        >
          <Home strokeWidth={1} />
          <span>Home</span>
        </NavLink>

        {/* CATEGORIES */}
        <div
          className={`tab-item ${showCategories ? "active-tab" : ""}`}
          onClick={() => setShowCategories(!showCategories)}
        >
          <LayoutGrid
            size={22}
            color={showCategories ? "#000" : "#999"}
            fill={showCategories ? "#000" : "none"}
            strokeWidth={1}
          />
          <span className={showCategories ? "active" : ""}>Categories</span>
        </div>

        {/* CART */}
        <NavLink to="/cart" className="tab-item cart-tab">
          {({ isActive }) => (
            <div className="icon-wrapper cart-icon-wrapper">
              <ShoppingCart
                size={22}
                color={isActive ? "#000" : "#999"}
                fill={isActive ? "#000" : "none"}
                strokeWidth={1}
              />

              {countData?.cart_count > 0 && (
                <span className="cart-badge_mlb">{countData.cart_count}</span>
              )}

              <span className={isActive ? "active" : ""}>Cart</span>
            </div>
          )}
        </NavLink>

        {/* WISHLIST */}
        <div className="tab-item wishlist-tab" onClick={handleWishlistClick}>
          <div className="icon-wrapper wishlist-icon-wrapper">
            <Heart size={22} color="#999" strokeWidth={1} />

            {countData?.wishlist_count > 0 && (
              <span className="wishlist-badge_mlb">
                {countData.wishlist_count}
              </span>
            )}

            <span>Wishlist</span>
          </div>
        </div>

        {/* WHATSAPP SUPPORT */}
        <NavLink
          to={`https://api.whatsapp.com/send?phone=${wdata?.phone}&text=${wdata?.text}`}
          target="_blank"
          className="tab-item"
          style={{ opacity:"0"}}
        >
          <div className="icon-wrapper wishlist-icon-wrapper">
            <FaWhatsapp size={22} color="#25D366" />
            <span>Support</span>
          </div>
        </NavLink>
      </div>

      {/* WISHLIST MODAL */}
      {showwishlist && (
        <WishlistModal onClose={() => setShowwishlist(false)} />
      )}

      {/* CATEGORY DRAWER */}
      <div className={`category-drawer ${showCategories ? "open" : ""}`}>
        <div className="drawer-header_btm">
          <h3>Categories</h3>

          <button
            className="close-btn-nav"
            onClick={() => setShowCategories(false)}
          >
            <X size={20} />
          </button>
        </div>

        <div className="category-list_mlb">
          {categories.length > 0 ? (
            categories.map((cat) => (
              <Link
                key={cat.id}
                to={getCategoryUrl(cat.action_url)}
                onClick={() => setShowCategories(false)}
              >
                <div className="category-item">
                  <img src={cat.media} alt={cat.name} />
                  <span>{cat.name}</span>
                </div>
              </Link>
            ))
          ) : (
            <p className="empty-text">Loading categories…</p>
          )}
        </div>
      </div>
    </>
  );
};

export default BottomTab;